var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"a",attrs:{"id":"test","href":"javascript:;"},on:{"click":function($event){return _vm.openFancybox()}}},[_vm._v("Slideshow")])])
}
var staticRenderFns = []

export { render, staticRenderFns }